import { useEffect } from 'react';
import gsap from 'gsap/all';
import { Text, Container } from '@weareconceptstudio/core';

//* Style
import ContentStyle from './style';

//* Components
import Share from '@/components/Share';
import Editor from '@/components/Editor';

const Content = ({ category, date, description, isLoading }) => {
	useEffect(() => {
		if (isLoading)
			gsap.to('.wrapper-editor-content', { opacity: 1, ease: 'power1.out', duration: 0.6, delay: 0.8 });
	}, [isLoading]);

	return (
		<ContentStyle className='wrapper-editor-content opacity-zero'>
			<Container
				row
				full
				isSection>
				<div className='col-2 col-t-1 empty' />

				<div className={'wrapper-content col-8 col-t-10 col-m-12'}>
					<div className='wrapper-category'>
						{/* <Text className={'p3 font-montserrat-arm-medium first-letter'}>{category.name}</Text> */}

						<Text className={'p3 font-montserrat-arm-medium first-letter'}>{date}</Text>
					</div>

					<div className='wrapper-editor'>
						<Editor data={description} />
					</div>

					<div className='wrapper-share'>
						<Share />
					</div>
				</div>

				<div className='col-2 col-t-1 empty' />
			</Container>
		</ContentStyle>
	);
};

export default Content;
